var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAileronSemiboldWebfont(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "aileronsemibold",
    horizAdvX: 1230
  }, /*#__PURE__*/React.createElement("fontFace", {
    unitsPerEm: 2048,
    ascent: 1577,
    descent: -471
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 421
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB01",
    horizAdvX: 1142,
    d: "M43 922v157h117v25q0 90 4 127q15 155 126.5 234t340.5 79q77 0 141 -12v-168q-202 15 -286.5 -18.5t-96.5 -126.5q-6 -43 -6 -103v-37h612v-1079h-223v922h-389v-922h-223v922h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB02",
    horizAdvX: 1128,
    d: "M43 922v157h96v25q0 86 4 123q32 317 453 317q223 0 354 -45v-1167q0 -70 2 -103q4 -51 33 -68t98 -9v-154q-82 -10 -153 -10q-92 0 -144.5 41.5t-56.5 140.5q-2 41 -2 156v1040q-57 14 -137 14q-201 0 -221 -161q-7 -51 -7 -103v-37h224v-157h-224v-922h-223v922h-96z "
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 682
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    horizAdvX: 421
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\t",
    horizAdvX: 421
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    horizAdvX: 421
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 516,
    d: "M113 115q0 63 41 104t104 41t103 -41t40 -104t-40 -103.5t-103 -40.5t-104 40.5t-41 103.5zM137 1413h240l-25 -1028h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 731,
    d: "M147 1505h215l-24 -534h-168zM459 1505h215l-23 -534h-168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    d: "M143 440v135h211l56 265h-205v135h233l94 438h142l-94 -438h184l94 438h141l-94 -438h180v-135h-208l-56 -265h203v-135h-231l-95 -440h-141l94 440h-184l-94 -440h-142l95 440h-183zM496 575h184l55 265h-184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    d: "M102 389h230q12 -99 70.5 -162t154.5 -82v476q-98 29 -168 63.5t-124.5 83t-81.5 115t-27 153.5q0 174 111.5 278t289.5 124v159h139v-157q186 -18 291.5 -128t126.5 -280h-229q-23 203 -189 238v-447q232 -73 330 -177t98 -271q0 -113 -56.5 -200.5t-152 -137 t-219.5 -62.5v-159h-139v157q-203 15 -324 123t-131 293zM381 1065q0 -88 42 -137.5t134 -79.5v422q-83 -14 -129.5 -66.5t-46.5 -138.5zM696 143q94 12 146.5 64.5t52.5 146.5q0 83 -45 141.5t-154 96.5v-449z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 1538,
    d: "M80 1106q0 153 83 241.5t226 88.5q142 0 225.5 -88.5t83.5 -241.5t-83.5 -242.5t-225.5 -89.5q-143 0 -226 89t-83 243zM215 0l918 1413h196l-917 -1413h-197zM264 1106q0 -95 33 -146t92 -51q58 0 91.5 51.5t33.5 145.5t-33.5 144t-91.5 50q-59 0 -92 -50t-33 -144z M840 303q0 153 83.5 241.5t225.5 88.5q143 0 226 -88.5t83 -241.5q0 -154 -83 -243t-226 -89q-142 0 -225.5 89.5t-83.5 242.5zM1024 303q0 -94 33.5 -145.5t91.5 -51.5q59 0 92 51t33 146q0 94 -33 144.5t-92 50.5q-58 0 -91.5 -50.5t-33.5 -144.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 1357,
    d: "M121 356q0 136 89 235t241 130q-120 32 -192.5 115t-72.5 202q0 184 140.5 294t371.5 110q128 0 236 -21v-172q-110 21 -238 21q-127 0 -196.5 -61t-69.5 -169q0 -220 236 -231q37 -2 125 -2h100v211h225v-211h195v-180h-195v-609q-206 -47 -430 -47q-130 0 -228.5 18.5 t-176.5 61.5t-119 119.5t-41 185.5zM365 389q0 -134 77.5 -190t247.5 -56q99 0 201 17v467h-109q-79 0 -120 -2q-150 -13 -223.5 -76t-73.5 -160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 382,
    d: "M82 1505h215l-25 -534h-168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 690,
    d: "M215 717q0 253 69.5 480.5t196.5 399.5h133q-249 -402 -249 -880q0 -479 249 -881h-133q-127 171 -196.5 400t-69.5 481z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 688,
    d: "M66 -164q249 402 249 881q0 478 -249 880h133q127 -172 196.5 -399.5t69.5 -480.5q0 -252 -69.5 -481t-196.5 -400h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    horizAdvX: 1183,
    d: "M188 598l48 147l301 -120l-23 348h156l-23 -348l301 120l47 -147l-313 -78l225 -268l-125 -92l-190 299l-191 -299l-125 92l226 268z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    d: "M178 582v131h367v415h141v-415h367v-131h-367v-412h-141v412h-367z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 475,
    d: "M-61 -248l161 490h228v-21l-193 -469h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 581,
    d: "M66 512v135h450v-135h-450z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 475,
    d: "M78 121q0 66 41.5 107.5t107.5 41.5q65 0 107.5 -41.5t42.5 -107.5q0 -65 -42.5 -107.5t-107.5 -42.5q-66 0 -107.5 42.5t-41.5 107.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 643,
    d: "M-10 -61l514 1536h149l-514 -1536h-149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    d: "M86 707q0 735 528 735q529 0 529 -735q0 -736 -529 -736q-115 0 -205.5 36t-150.5 100.5t-99 158t-56 202t-17 239.5zM330 707q0 -279 68.5 -421.5t215.5 -142.5q149 0 217 142.5t68 421.5q0 282 -68 422.5t-217 140.5q-148 0 -216 -141t-68 -422z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    d: "M260 948v221l311 191q90 53 189 53h125v-1413h-226v1178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    d: "M123 0v115l493 497q141 140 198.5 228.5t57.5 185.5q0 108 -60 177t-171 69q-232 0 -260 -289l-2 -20h-225l2 20q22 224 153.5 342.5t356.5 118.5q216 0 333 -111t117 -286q0 -134 -75.5 -252t-270.5 -308l-311 -307h649v-180h-985z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    d: "M86 426h225l2 -20q15 -127 95.5 -195t203.5 -68t199 66.5t76 179.5q0 241 -309 244h-41v166l41 2q123 2 199.5 69t76.5 183q0 97 -61.5 157t-163.5 60q-106 0 -176 -66.5t-82 -185.5l-2 -21h-224l2 21q19 194 150.5 309t355.5 115q208 0 326.5 -101t118.5 -262 q0 -122 -67.5 -208.5t-188.5 -120.5q138 -34 213 -123.5t75 -227.5q0 -129 -70.5 -227.5t-190 -149.5t-267.5 -51q-224 0 -357.5 108t-156.5 327z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    d: "M70 346v117l684 950h231v-887h178v-180h-178v-346h-223v346h-692zM334 526h428v613q-63 -108 -107 -166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    d: "M117 401h225l2 -20q48 -238 266 -238q131 0 207 83t76 227t-74 229.5t-203 85.5q-93 0 -157 -43t-109 -139h-211l101 827h837v-178h-655l-57 -449l79 97q96 57 222 57q225 0 348 -131t123 -346q0 -114 -43.5 -209t-116 -156t-166 -94t-195.5 -33q-224 0 -349.5 103 t-147.5 307z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    d: "M94 649q0 200 44 354.5t121.5 249t178 142t219.5 47.5q194 0 315.5 -104.5t141.5 -282.5l2 -21h-233l-4 21q-50 215 -238 215q-290 0 -309 -531l76 127q104 86 256 86q220 0 343 -131t123 -340q0 -153 -69.5 -270t-186.5 -178.5t-262 -61.5q-518 0 -518 678zM344 459 q0 -137 73.5 -226.5t194.5 -89.5q122 0 198.5 87.5t76.5 224.5q0 145 -69.5 235t-207.5 90q-113 0 -189.5 -84.5t-76.5 -236.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    d: "M106 1235v178h1037v-113l-692 -1300h-242l665 1235h-768z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    d: "M94 397q0 126 80 220t199 131q-98 37 -156.5 116t-58.5 193q0 176 127 280.5t344 104.5q218 0 344.5 -104.5t126.5 -280.5q0 -114 -65 -193.5t-169 -115.5q117 -37 194 -131t77 -220q0 -112 -43.5 -196.5t-118.5 -134t-165.5 -73.5t-195.5 -24q-112 0 -204 24t-164 73.5 t-112 133.5t-40 197zM336 395q0 -116 73 -185t209 -69t205.5 68.5t69.5 185.5q0 111 -69.5 182.5t-207.5 71.5q-136 0 -208 -71.5t-72 -182.5zM393 1049q0 -103 61 -165.5t173 -62.5q113 0 175 62.5t62 165.5q0 98 -61 159.5t-174 61.5q-112 0 -174 -62t-62 -159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    d: "M100 932q0 153 69 270t185.5 178.5t261.5 61.5q256 0 388.5 -164.5t132.5 -513.5q0 -200 -44 -354.5t-122 -249t-178.5 -142t-219.5 -47.5q-195 0 -317 104.5t-139 284.5l-2 21h233l4 -21q46 -217 238 -217q289 0 309 531l-76 -127q-107 -86 -256 -86q-220 0 -343.5 131 t-123.5 340zM344 958q0 -144 69 -234.5t205 -90.5q115 0 192 84.5t77 236.5q0 137 -74.5 226.5t-194.5 89.5q-122 0 -198 -87.5t-76 -224.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 475,
    d: "M78 121q0 66 41.5 107.5t107.5 41.5q65 0 107.5 -41.5t42.5 -107.5q0 -65 -42.5 -107.5t-107.5 -42.5q-66 0 -107.5 42.5t-41.5 107.5zM78 967q0 66 41.5 107.5t107.5 41.5q65 0 107.5 -41.5t42.5 -107.5q0 -65 -42.5 -107.5t-107.5 -42.5q-66 0 -107.5 42.5t-41.5 107.5 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 475,
    d: "M-61 -248l161 506h230v-29l-195 -477h-196zM78 967q0 66 41.5 107.5t107.5 41.5q65 0 107.5 -41.5t42.5 -107.5q0 -65 -42.5 -107.5t-107.5 -42.5q-66 0 -107.5 42.5t-41.5 107.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    d: "M213 457v174l858 399v-166l-713 -319l713 -320v-168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    d: "M168 377v131h895v-131h-895zM168 786v132h895v-132h-895z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    d: "M141 57v164l711 320l-711 319v170l856 -399v-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 1069,
    d: "M70 1001q6 202 137 321.5t344 119.5q209 0 326.5 -104.5t117.5 -274.5q0 -110 -51.5 -205.5t-163.5 -202.5q-90 -87 -121.5 -140.5t-37.5 -129.5h-207q7 97 40.5 166.5t114.5 161.5q105 118 144 189.5t39 152.5q0 99 -55.5 157t-155.5 58q-106 0 -169.5 -68.5 t-72.5 -200.5h-229zM375 115q0 63 40 104t103 41t104.5 -41t41.5 -104t-41.5 -103.5t-104.5 -40.5t-103 40.5t-40 103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 1785,
    d: "M106 502q0 158 47.5 298t130.5 244.5t193.5 181t239 115.5t262.5 39q206 0 364 -90t242 -247t84 -355q0 -138 -37.5 -244.5t-100.5 -169t-138.5 -93.5t-159.5 -31q-197 0 -232 163l-47 -96q-95 -76 -198 -76q-54 0 -102.5 17t-91 54t-68 104.5t-25.5 158.5 q0 137 53.5 255t153.5 190.5t223 72.5q119 0 174 -61l21 -107l39 131h200l-112 -473q-17 -69 -17 -106q0 -88 80 -88q96 0 166 102.5t70 288.5q0 135 -42 243t-116.5 176.5t-173.5 105t-215 36.5q-132 0 -259 -50t-229.5 -140.5t-165.5 -232t-63 -310.5q0 -191 77 -327.5 t209 -203.5t304 -67q130 0 263 40t237 116l55 -119q-263 -176 -567 -176q-141 0 -268.5 44.5t-231.5 131t-166 230t-62 325.5zM698 489q0 -184 121 -184q70 0 123.5 61t73.5 146l22 96q26 114 -6 167.5t-102 53.5q-103 0 -167.5 -101t-64.5 -239z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 1343,
    d: "M47 0l508 1413h291l493 -1413h-243l-154 467h-502l-153 -467h-240zM500 645h383l-187 582z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 1312,
    d: "M195 0v1413h456q115 0 185 -8q170 -23 261 -112t91 -236q0 -223 -232 -301q283 -69 283 -338q0 -93 -32 -168t-86.5 -123t-119 -77t-137.5 -40q-70 -10 -188 -10h-481zM420 180h278q70 0 97 2q91 8 148.5 67.5t57.5 158.5q0 205 -208 229q-41 6 -107 6h-266v-463z M420 817h246q57 0 106 8q178 28 178 207q0 90 -51.5 139t-140.5 58q-49 6 -107 6h-231v-418z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 1449,
    d: "M100 700q0 164 50 303t139 235t214.5 150t272.5 54q267 0 417 -132.5t173 -351.5l2 -20h-223l-4 20q-30 148 -122 230t-247 82q-195 0 -311.5 -153.5t-116.5 -405.5q0 -261 114.5 -414.5t303.5 -153.5q154 0 245.5 83.5t122.5 232.5l5 20h223l-2 -20q-23 -216 -180 -352 t-424 -136q-198 0 -347 92.5t-227 257.5t-78 379z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 1472,
    d: "M195 0v1413h456q108 0 180 -8q125 -15 227.5 -63.5t180 -131t120 -206.5t42.5 -281q0 -155 -44 -283.5t-122 -217.5t-183 -144t-229 -70q-72 -8 -180 -8h-448zM420 180h203q116 0 161 8q173 25 274 164.5t101 370.5q0 219 -97 348t-269 154q-56 10 -162 10h-211v-1055z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 1228,
    d: "M195 0v1413h956v-178h-731v-438h674v-179h-674v-438h751v-180h-976z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 1185,
    d: "M195 0v1413h956v-178h-731v-438h653v-179h-653v-618h-225z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 1478,
    d: "M100 700q0 164 50.5 303t140 235t216 150t273.5 54q268 0 418.5 -132.5t173.5 -351.5l2 -20h-225l-4 20q-29 148 -121 230t-248 82q-196 0 -314 -154t-118 -405q0 -261 116 -414.5t306 -153.5q157 0 260.5 103.5t112.5 273.5h-316v180h535v-700h-189l-8 240l-63 -138 q-122 -131 -357 -131q-198 0 -344 92.5t-221.5 257t-75.5 379.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 1515,
    d: "M195 0v1413h225v-629h725v629h223v-1413h-223v602h-725v-602h-225z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 567,
    d: "M195 0v1413h225v-1413h-225z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 1163,
    d: "M109 496h225l4 -78q14 -275 250 -275q110 0 168 64.5t67 183.5q2 43 2 158v864h226v-854q0 -89 -7 -182q-11 -188 -130 -297t-347 -109q-216 0 -333 118.5t-123 328.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 1316,
    d: "M195 0v1413h225v-719l657 719h266l-634 -684l602 -729h-301l-465 590l-125 -135v-455h-225z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 1204,
    d: "M195 0v1413h225v-1227h751v-186h-976z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 1802,
    d: "M195 0v1413h362l373 -1212l373 1212h352v-1413h-223v694q0 356 4 506q-61 -224 -154 -504l-227 -696h-260l-230 698q-98 303 -149 500q4 -152 4 -504v-694h-225z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 1509,
    d: "M195 0v1413h317l633 -1173q-6 240 -6 493v680h221l2 -1413h-324l-626 1165q8 -216 8 -489v-676h-225z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    horizAdvX: 1536,
    d: "M100 707q0 164 46 299.5t132 232t215 150t289 53.5q212 0 367 -92.5t234 -258t79 -384.5t-79 -384t-234 -258.5t-367 -93.5q-213 0 -368.5 93.5t-234.5 258.5t-79 384zM342 707q0 -263 117 -413.5t323 -150.5q205 0 322 150.5t117 413.5q0 264 -116.5 413.5t-322.5 149.5 q-207 0 -323.5 -149.5t-116.5 -413.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 1249,
    d: "M195 0v1413h462q127 0 193 -8q171 -22 272 -130t101 -290q0 -91 -29.5 -167t-80.5 -127.5t-118 -83.5t-145 -42q-66 -8 -193 -8h-237v-557h-225zM420 739h244q88 0 143 9q80 15 129 73t49 164t-49 164.5t-129 73.5q-49 8 -143 8h-244v-492z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    horizAdvX: 1531,
    d: "M100 707q0 164 46 299.5t132 232t215 150t289 53.5q212 0 367 -92.5t234 -258t79 -384.5q0 -167 -62.5 -304.5t-180.5 -224.5q125 -22 258 -133l-121 -149q-98 64 -157.5 86t-121.5 22q-63 0 -149 -18q-68 -15 -146 -15q-213 0 -368.5 93.5t-234.5 258.5t-79 384z M342 707q0 -263 117 -413.5t323 -150.5q205 0 322 150.5t117 413.5q0 264 -116.5 413.5t-322.5 149.5q-207 0 -323.5 -149.5t-116.5 -413.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 1300,
    d: "M195 0v1413h487q127 0 195 -8q165 -22 261.5 -113.5t96.5 -263.5q0 -132 -71.5 -217t-190.5 -121q170 -74 194 -325q12 -137 34.5 -222.5t64.5 -142.5h-248q-50 125 -72 336q-14 118 -62 182t-141 70q-35 2 -104 2h-219v-590h-225zM420 764h235q92 0 127 4 q98 10 156.5 67t58.5 164q0 108 -50 161.5t-146 66.5q-49 8 -131 8h-250v-471z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 1218,
    d: "M98 410h234q27 -129 113 -198t212 -69q113 0 189 57.5t76 151.5q0 110 -72 173.5t-244 103.5q-107 25 -184 56.5t-138.5 79t-92.5 115.5t-31 158q0 121 67 214.5t177 141.5t243 48q225 0 349 -117.5t147 -312.5h-234q-12 123 -82 190.5t-192 67.5q-105 0 -171.5 -49.5 t-66.5 -145.5q0 -102 68.5 -157.5t234.5 -94.5q236 -55 347.5 -160t111.5 -280q0 -124 -68.5 -219t-182 -144t-251.5 -49q-245 0 -391 113.5t-168 325.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 1263,
    d: "M59 1235v178h1211v-178h-494v-1235h-223v1235h-494z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 1415,
    d: "M180 547v866h223v-870q0 -74 5 -115q11 -132 94 -208.5t231 -76.5q150 0 233.5 76.5t94.5 208.5q4 33 4 115v870h223v-866q0 -93 -4 -146q-8 -91 -43.5 -167t-100.5 -136t-169 -93.5t-238 -33.5t-238 33.5t-169 93.5t-100 136t-42 167q-4 53 -4 146z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 1335,
    d: "M66 1413h243l400 -1241l409 1241h240l-508 -1413h-291z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 1982,
    d: "M53 1413h248l270 -1227l293 1207h310l284 -1213l287 1233h233l-385 -1413h-297l-282 1204l-297 -1204h-299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 1327,
    d: "M45 0l506 713l-469 700h258l348 -553l363 553h258l-492 -694l508 -719h-262l-385 571l-369 -571h-264z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    horizAdvX: 1232,
    d: "M37 1413h256l364 -653l353 653h250l-500 -860v-553h-223v553z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 1239,
    d: "M98 0v172l820 1063h-762v178h1024v-176l-813 -1057h823v-180h-1092z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 681,
    d: "M207 -164v1761h389v-135h-250v-1491h250v-135h-389z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 643,
    d: "M-10 1475h149l514 -1536h-149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 663,
    d: "M68 -29h249v1491h-249v135h389v-1761h-389v135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    d: "M176 440l356 822h164l357 -822h-162l-275 686l-276 -686h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 1024,
    d: "M102 -43h820v-135h-820v135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 614,
    d: "M47 1417h205l139 -233h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 1116,
    d: "M72 285q0 372 604 372h69v27q0 78 -4 119q-10 149 -190 149q-192 0 -211 -209h-225q10 176 130.5 274.5t309.5 98.5q202 0 299 -78.5t111 -224.5q6 -68 6 -154v-383q0 -125 20 -276h-223l-20 158l-56 -117q-102 -70 -270 -70q-151 0 -250.5 83.5t-99.5 230.5zM309 303 q0 -84 51.5 -126t143.5 -42q108 0 174.5 72t66.5 201v100q-50 4 -95 4q-76 0 -136 -11q-96 -17 -150.5 -67t-54.5 -131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 1282,
    d: "M141 0v1505h226v-587l82 116q45 38 122.5 60t161.5 22q152 0 264 -72.5t169 -197t57 -283.5q0 -145 -42.5 -260t-116 -186.5t-167.5 -108.5t-201 -37q-71 0 -144.5 18.5t-113.5 49.5l-71 108v-147h-226zM367 500q0 -95 27 -168.5t71.5 -114.5t96.5 -61.5t108 -20.5 q140 0 227.5 106t87.5 302q0 182 -80.5 295.5t-224.5 113.5q-66 0 -120.5 -21.5t-98.5 -67t-69 -124t-25 -184.5v-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 1114,
    d: "M59 539q0 135 42 246t114.5 182.5t167.5 110t203 38.5q202 0 328 -111t147 -294h-227q-48 241 -254 241q-125 0 -204 -101t-79 -296q0 -211 76 -315.5t198 -104.5q97 0 163 58t91 167h230q-37 -191 -168 -290t-328 -99q-224 0 -362 144.5t-138 423.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 1288,
    d: "M59 526q0 144 42.5 258.5t116 186t167.5 108.5t201 37q71 0 144.5 -18t113.5 -49l71 -109v565h226v-1505h-226v172l-81 -119q-46 -37 -124 -59.5t-161 -22.5q-228 0 -359 155t-131 400zM297 545q0 -182 80 -296t223 -114q66 0 121 21.5t99.5 67t69.5 124t25 184.5v58 q0 95 -27 167.5t-72 113.5t-97 61t-109 20q-139 0 -226 -105.5t-87 -301.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 1150,
    d: "M59 541q0 257 148.5 416t384.5 159q153 0 264.5 -73t166 -194.5t54.5 -277.5q0 -51 -4 -90h-780q24 -346 285 -346q100 0 169.5 58t86.5 159h227q-34 -186 -169 -283.5t-323 -97.5q-228 0 -369 146t-141 424zM295 639h551q-12 152 -78.5 232.5t-183.5 80.5 q-118 0 -194.5 -79.5t-94.5 -233.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 638,
    d: "M43 922v157h117v70q0 92 4 129q14 128 99 197t237 69q70 0 125 -12v-168q-44 8 -80 8q-48 0 -84 -14q-63 -25 -72 -92q-6 -44 -6 -105v-82h223v-157h-223v-922h-223v922h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 1288,
    d: "M59 530q0 144 42.5 258t116 184.5t167.5 107t201 36.5q71 0 144.5 -18t113.5 -49l71 -109v147h226v-817q0 -152 -2 -211q-9 -244 -152 -369.5t-393 -125.5q-232 0 -358.5 93.5t-143.5 270.5l-2 21h221l2 -19q11 -90 85 -143t198 -53q148 0 229.5 77.5t87.5 223.5 q2 47 2 125v22l-81 -119q-46 -37 -121 -59t-158 -22q-230 0 -363 152t-133 396zM297 551q0 -182 80 -294t223 -112q139 0 227 96.5t88 301.5v47q0 95 -27 167.5t-72 113.5t-97 61t-109 20q-140 0 -226.5 -103t-86.5 -298z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 1241,
    d: "M141 0v1516h226v-609l73 125q62 48 125.5 66t149.5 18q172 0 272 -83t115 -228q6 -83 6 -193v-612h-225v588q0 98 -4 153q-8 98 -64 154q-55 55 -162 55h-4q-128 -3 -205 -113t-77 -350v-487h-226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 514,
    d: "M123 1337q0 56 37 92.5t94 36.5t95 -37t38 -92q0 -57 -38 -94t-95 -37t-94 37t-37 94zM141 0v1087h226v-1087h-226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 501,
    d: "M-45 -256q21 -2 39 -2q58 0 88 18q41 22 47 78q4 29 4 92v1157h223v-1150q0 -58 -4 -132q-11 -117 -82.5 -176t-220.5 -59q-65 0 -94 4v170zM113 1337q0 59 36 94t97 35q60 0 95.5 -35t35.5 -94q0 -60 -35.5 -95.5t-95.5 -35.5q-61 0 -97 35.5t-36 95.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 1126,
    d: "M141 0v1505h226v-942l475 524h276l-495 -509l501 -578h-293l-368 446l-96 -106v-340h-226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 536,
    d: "M133 326v1179h225v-1173q0 -70 2 -103q2 -47 30 -63q20 -12 64 -12q16 0 35 2v-158q-75 -10 -147 -10q-96 0 -148.5 41.5t-58.5 140.5q-2 41 -2 156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 1808,
    d: "M141 0v1087h226v-161l73 127q80 63 232 63q125 0 207 -56t114 -151l101 144q83 63 231 63q145 0 232.5 -74t107.5 -192q10 -69 10 -193v-657h-225v575q0 124 -8 197q-10 87 -62.5 132.5t-140.5 45.5q-219 0 -219 -403v-547h-223v575q0 115 -9 197q-24 178 -202 178 q-219 0 -219 -403v-547h-226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 1241,
    d: "M141 0v1087h226v-180l73 125q62 48 125.5 66t149.5 18q172 0 272 -83t115 -228q6 -83 6 -193v-612h-225v588q0 98 -4 153q-8 98 -64 153.5t-166 55.5q-127 0 -204.5 -111t-77.5 -352v-487h-226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 1218,
    d: "M59 545q0 120 35 223t102 181t173.5 122.5t240.5 44.5q133 0 239.5 -44.5t173.5 -122.5t102.5 -181t35.5 -223t-35.5 -223.5t-102.5 -182t-173.5 -123.5t-239.5 -45q-134 0 -240.5 45t-173.5 123.5t-102 182t-35 223.5zM297 545q0 -187 83 -298.5t230 -111.5 q146 0 229 111.5t83 298.5t-83 297t-229 110q-147 0 -230 -110t-83 -297z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 1282,
    d: "M141 -401v1488h226v-169l82 116q45 38 122.5 60t161.5 22q152 0 264 -72.5t169 -197t57 -283.5q0 -145 -42.5 -260t-116 -186.5t-167.5 -108.5t-201 -37q-71 0 -144.5 18.5t-113.5 49.5l-71 108v-548h-226zM367 500q0 -95 27 -168.5t71.5 -114.5t96.5 -61.5t108 -20.5 q140 0 227.5 106t87.5 302q0 182 -80.5 295.5t-224.5 113.5q-66 0 -120.5 -21.5t-98.5 -67t-69 -124t-25 -184.5v-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    horizAdvX: 1288,
    d: "M59 526q0 144 42.5 258.5t116 186t167.5 108.5t201 37q71 0 144.5 -18t113.5 -49l71 -109v147h226v-1488h-226v573l-81 -119q-46 -37 -124 -59.5t-161 -22.5q-228 0 -359 155t-131 400zM297 545q0 -182 80 -296t223 -114q66 0 121 21.5t99.5 67t69.5 124t25 184.5v58 q0 95 -27 167.5t-72 113.5t-97 61t-109 20q-139 0 -226 -105.5t-87 -301.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 722,
    d: "M141 0v1087h226v-184l92 150q77 61 168 61q41 0 75 -12v-176q-18 1 -34 1q-136 -1 -214 -79q-88 -88 -87 -283v-565h-226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 974,
    d: "M47 326h227q19 -100 80.5 -147.5t151.5 -47.5q82 0 135 35.5t53 103.5q0 70 -59 114t-199 81q-80 20 -139 46t-107.5 64t-74 92.5t-25.5 123.5q0 151 109.5 238t292.5 87q182 0 288 -92.5t125 -247.5h-229q-18 88 -68.5 135t-132.5 47q-77 0 -117.5 -38.5t-40.5 -102.5 q0 -70 56 -109t186 -73q186 -48 274.5 -128t88.5 -220q0 -152 -118.5 -234t-305.5 -82q-189 0 -309 88.5t-142 266.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 686,
    d: "M33 922v157h153v260h224v-260h213v-157h-213v-570q0 -61 2 -90q6 -78 46 -102q27 -16 86 -17q28 0 64 4v-155q-86 -12 -166 -12q-127 0 -186.5 49t-67.5 157q-2 37 -2 146v590h-153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 1236,
    d: "M125 440v647h223v-602q0 -76 8 -149q12 -92 72 -144.5t162 -52.5q127 0 201.5 105.5t74.5 330.5v512h224v-1087h-224v186l-75 -135q-63 -44 -126.5 -62t-148.5 -18q-161 0 -261 79t-120 198q-10 69 -10 192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 1101,
    d: "M2 1087h248l305 -921l301 921h240l-416 -1087h-262z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 1650,
    d: "M2 1087h254l223 -886l211 884h275l217 -886l223 888h240l-347 -1087h-258l-215 879l-217 -879h-260z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 1042,
    d: "M-10 0l387 551l-373 536h264l248 -393l246 393h258l-379 -534l383 -553h-260l-258 410l-258 -410h-258z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 1099,
    d: "M2 1087h252l299 -919l297 919h244l-443 -1157q-75 -194 -170 -277t-243 -83q-74 0 -107 6v166q27 -2 72 -2q79 0 132 39t89 131l16 39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 978,
    d: "M49 0v156l613 762h-572v161h821v-161l-608 -756h617v-162h-871z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 686,
    d: "M156 649v135q92 9 130 46.5t38 101.5q0 59 -21 215q-24 162 -24 229q0 121 67.5 171t210.5 50h43v-135h-31q-84 0 -117.5 -22.5t-33.5 -73.5q0 -44 22 -199q27 -197 27 -241q0 -86 -44.5 -139t-129.5 -68q83 -14 128.5 -68.5t45.5 -142.5q0 -46 -27 -242 q-22 -153 -22 -198q0 -51 33.5 -74t117.5 -23h31v-135h-43q-143 0 -210.5 50.5t-67.5 172.5q0 66 24 228q21 156 21 215q0 66 -38 103t-130 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 544,
    d: "M199 -410v2048h147v-2048h-147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 686,
    d: "M86 -29h31q84 0 117.5 23t33.5 74q0 45 -22 198q-27 197 -27 242q0 88 44.5 140.5t129.5 66.5q-83 13 -128.5 68.5t-45.5 142.5q0 44 27 241q22 155 22 199q0 51 -33.5 73.5t-117.5 22.5h-31v135h43q143 0 211 -50t68 -171q0 -60 -25 -229q-21 -156 -21 -215 q0 -64 38 -101.5t130 -46.5v-135q-92 -7 -130 -44t-38 -103q0 -59 21 -215q25 -169 25 -228q0 -122 -68 -172.5t-211 -50.5h-43v135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    d: "M164 457q0 299 235 299q58 0 105.5 -18t138.5 -66q72 -39 112.5 -55.5t78.5 -16.5q54 0 76 38t22 118h135q0 -299 -238 -299q-39 0 -78.5 11t-69 25t-93.5 48q-71 38 -112.5 54.5t-78.5 16.5q-54 0 -76 -38.5t-22 -116.5h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    horizAdvX: 516,
    d: "M113 971q0 63 41 103t104 40t103 -40t40 -103t-40 -104.5t-103 -41.5t-104 41.5t-41 104.5zM137 -328l25 1030h190l25 -1030h-240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    horizAdvX: 1200,
    d: "M109 539q0 239 123.5 388.5t316.5 180.5v162h139v-158q180 -15 291.5 -124t130.5 -279h-217q-42 203 -205 235v-801q74 18 125.5 73t71.5 144h219q-33 -170 -142 -268t-274 -117v-159h-139v157q-200 20 -320 163.5t-120 402.5zM336 553q0 -176 58.5 -278t154.5 -130v793 q-96 -28 -154.5 -125.5t-58.5 -259.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    d: "M137 0v160q115 26 166 97.5t51 168.5q0 103 -45 209h-153v131h94q-60 139 -60 250q0 191 129.5 308.5t327.5 117.5q106 0 190 -31.5t138 -88t84.5 -129.5t36.5 -161h-234q-27 238 -219 238q-100 0 -154.5 -65.5t-54.5 -157.5q0 -72 15 -129t57 -152h430v-131h-379 q31 -85 31 -176q0 -186 -172 -279h688v-180h-967z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    d: "M195 289l116 117q-65 94 -65 210t65 213l-116 117l92 92l119 -118q94 65 208 65q117 0 211 -65l121 118l92 -92l-120 -119q65 -94 65 -211q0 -114 -65 -208l120 -119l-92 -92l-119 118q-95 -67 -213 -67q-117 0 -211 65l-116 -116zM395 616q0 -101 62.5 -166t156.5 -65 q96 0 159 65t63 166t-63 166.5t-159 65.5q-94 0 -156.5 -65.5t-62.5 -166.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    d: "M47 1413h258l318 -661l311 661h248l-371 -670h242v-135h-318l-8 -16v-111h326v-135h-326v-346h-223v346h-326v135h326v107l-10 20h-316v135h240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    horizAdvX: 536,
    d: "M199 -328v697h139v-697h-139zM199 717v696h139v-696h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    horizAdvX: 1183,
    d: "M61 604q0 107 52.5 184.5t144.5 120.5q-65 81 -65 189q0 157 110 250.5t285 93.5q183 0 289 -92.5t124 -253.5h-227q-17 90 -65.5 139t-124.5 49q-69 0 -113.5 -42.5t-44.5 -115.5q0 -84 62 -138t208 -93q226 -62 328 -154.5t102 -242.5q0 -98 -52.5 -175.5 t-141.5 -121.5q74 -90 74 -217q0 -108 -60 -187t-155 -116t-211 -37q-192 0 -312 90t-141 270h227q25 -103 86.5 -153t149.5 -50q81 0 131.5 42.5t50.5 121.5q0 87 -66.5 146t-242.5 104q-402 104 -402 389zM295 612q0 -76 70 -133t196 -90q119 -30 209 -74q57 19 90 62 t33 98q0 85 -66 139t-219 101q-115 34 -188 71q-58 -11 -91.5 -55t-33.5 -119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    horizAdvX: 614,
    d: "M35 1294q0 46 31 77.5t77 31.5t78.5 -31.5t32.5 -77.5q0 -45 -32.5 -75.5t-78.5 -30.5t-77 30t-31 76zM362 1294q0 46 31.5 77.5t77.5 31.5t77.5 -31.5t31.5 -77.5q0 -45 -31.5 -75.5t-77.5 -30.5t-77.5 30.5t-31.5 75.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    horizAdvX: 1728,
    d: "M63 727q0 169 61.5 319t168 256.5t255 168t316.5 61.5t316.5 -61.5t255 -168t168 -256.5t61.5 -319t-61.5 -319t-168 -256.5t-255 -168t-316.5 -61.5t-316.5 61.5t-255 168t-168 256.5t-61.5 319zM215 727q0 -188 84.5 -340.5t233 -239t331.5 -86.5q182 0 330.5 86.5 t233.5 239t85 340.5q0 140 -50 263.5t-136 212t-206.5 139.5t-256.5 51q-183 0 -331.5 -87t-233 -239.5t-84.5 -339.5zM428 725q0 217 123.5 345t327.5 128q171 0 277.5 -93t133.5 -251h-217q-28 188 -199 188q-107 0 -163 -83.5t-56 -229.5q0 -148 60 -232.5t162 -84.5 q79 0 131 51t63 135h217q-34 -160 -140 -251t-288 -91q-192 0 -312 128t-120 341z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    horizAdvX: 1212,
    d: "M260 508l281 340h178l-281 -340l281 -340h-178zM643 508l281 340h178l-281 -340l281 -340h-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    d: "M215 659v136h778v-383h-141v247h-637z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAD",
    horizAdvX: 581,
    d: "M66 512v135h450v-135h-450z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    horizAdvX: 1030,
    d: "M84 1135q0 189 120.5 309.5t309.5 120.5q190 0 310 -120.5t120 -309.5t-120 -309.5t-310 -120.5q-189 0 -309.5 120.5t-120.5 309.5zM188 1135q0 -145 91.5 -237.5t234.5 -92.5q144 0 235 92.5t91 237.5q0 146 -90.5 238.5t-235.5 92.5q-143 0 -234.5 -92.5t-91.5 -238.5 zM358 932v422h148q37 0 55 -2q137 -13 137 -115q0 -77 -84 -102q55 -13 62 -93q7 -67 26 -110h-120q-10 40 -15 90q-5 49 -59 49h-43v-139h-107zM465 1159h37q27 0 39 2q41 8 41 53q0 42 -41 52q-12 2 -39 2h-37v-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    horizAdvX: 614,
    d: "M47 1229v129h522v-129h-522z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    horizAdvX: 622,
    d: "M53 1190q0 112 72 182t186 70t186 -70t72 -182t-72 -182t-186 -70t-186 70t-72 182zM197 1190q0 -54 32 -87.5t82 -33.5q48 0 81.5 34t33.5 87t-33.5 87t-81.5 34q-50 0 -82 -33.5t-32 -87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    d: "M190 0v131h850v-131h-850zM190 586v135h355v342h141v-342h354v-135h-354v-350h-141v350h-355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    horizAdvX: 614,
    d: "M227 1184l142 233h204l-211 -233h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    horizAdvX: 1185,
    d: "M88 1034q0 153 85.5 260.5t236.5 116.5q35 2 114 2h514v-1638h-139v1503h-201v-1503h-139v880h-35q-79 0 -114 2q-151 9 -236.5 116.5t-85.5 260.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    horizAdvX: 454,
    d: "M70 625q0 67 45 112t112 45q68 0 113 -45t45 -112t-45.5 -112.5t-112.5 -45.5t-112 45t-45 113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    horizAdvX: 614,
    d: "M121 -309q49 -21 110 -21q63 0 95 21t32 59q0 49 -46 70t-150 14l96 184h125l-53 -102q85 -10 128.5 -52.5t43.5 -113.5q0 -88 -75 -134t-200 -46q-65 0 -106 16v105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    horizAdvX: 1196,
    d: "M111 168l280 340l-280 340h178l280 -340l-280 -340h-178zM494 168l280 340l-280 340h178l280 -340l-280 -340h-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    horizAdvX: 1040,
    d: "M127 27q0 108 52 204t163 201q89 86 121.5 141.5t38.5 131.5h207q-7 -98 -41 -167.5t-115 -162.5q-105 -118 -143.5 -189t-38.5 -153q0 -99 55.5 -157t155.5 -58q106 0 169 68t72 200h230q-6 -202 -137.5 -321t-344.5 -119q-209 0 -326.5 105t-117.5 276zM459 973 q0 63 41 103t104 40t103.5 -40t40.5 -103t-40.5 -104.5t-103.5 -41.5t-104 41.5t-41 104.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    horizAdvX: 1343,
    d: "M47 0l508 1413h291l493 -1413h-243l-154 467h-502l-153 -467h-240zM446 1716h205l129 -209h-135zM500 645h383l-187 582z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    horizAdvX: 1343,
    d: "M47 0l508 1413h291l493 -1413h-243l-154 467h-502l-153 -467h-240zM500 645h383l-187 582zM623 1507l129 209h204l-198 -209h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    horizAdvX: 1343,
    d: "M47 0l508 1413h291l493 -1413h-243l-154 467h-502l-153 -467h-240zM483 1507l135 209h166l136 -209h-156l-64 123l-63 -123h-154zM500 645h383l-187 582z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    horizAdvX: 1343,
    d: "M47 0l508 1413h291l493 -1413h-243l-154 467h-502l-153 -467h-240zM455 1532q0 96 31 137t94 41q57 0 137 -31q73 -24 90 -24q18 0 25.5 10.5t7.5 36.5h108q0 -96 -31.5 -137t-95.5 -41q-57 0 -137 30q-77 25 -90 25q-33 0 -33 -47h-106zM500 645h383l-187 582z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    horizAdvX: 1343,
    d: "M47 0l508 1413h291l493 -1413h-243l-154 467h-502l-153 -467h-240zM432 1610q0 45 32.5 76.5t78.5 31.5t77 -31t31 -77t-31 -77.5t-77 -31.5t-78.5 31.5t-32.5 77.5zM500 645h383l-187 582zM750 1610q0 46 32 77t78 31t77.5 -31t31.5 -77t-31.5 -77.5t-77.5 -31.5 t-78 31.5t-32 77.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    horizAdvX: 1343,
    d: "M47 0l508 1413h291l493 -1413h-243l-154 467h-502l-153 -467h-240zM500 645h383l-187 582zM500 1645q0 77 56 126.5t144 49.5t144.5 -49.5t56.5 -126.5q0 -76 -56.5 -125.5t-144.5 -49.5t-144 49t-56 126zM618 1645q0 -37 23.5 -61.5t58.5 -24.5t58.5 24.5t23.5 61.5 q0 38 -23 62t-59 24t-59 -24t-23 -62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    horizAdvX: 1904,
    d: "M-76 0l797 1413h1106v-178h-768l33 -438h677v-179h-665l33 -438h710v-180h-923l-35 481h-463l-260 -481h-242zM524 662h353l-43 571z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    horizAdvX: 1449,
    d: "M100 700q0 164 50 303t139 235t214.5 150t272.5 54q267 0 417 -132.5t173 -351.5l2 -20h-223l-4 20q-30 148 -122 230t-247 82q-195 0 -311.5 -153.5t-116.5 -405.5q0 -261 114.5 -414.5t303.5 -153.5q154 0 245.5 83.5t122.5 232.5l5 20h223l-2 -20q-23 -211 -174 -346 t-406 -142l-28 -55q85 -10 128.5 -52.5t43.5 -113.5q0 -88 -75 -134t-200 -46q-65 0 -106 16v105q49 -21 110 -21q63 0 95 21t32 59q0 49 -46 70t-150 14l75 143q-258 34 -406.5 229.5t-148.5 493.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    horizAdvX: 1228,
    d: "M195 0v1413h956v-178h-731v-438h674v-179h-674v-438h751v-180h-976zM436 1716h205l129 -209h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    horizAdvX: 1228,
    d: "M195 0v1413h956v-178h-731v-438h674v-179h-674v-438h751v-180h-976zM612 1507l129 209h205l-198 -209h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    horizAdvX: 1228,
    d: "M195 0v1413h956v-178h-731v-438h674v-179h-674v-438h751v-180h-976zM473 1507l135 209h166l135 -209h-155l-64 123l-63 -123h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    horizAdvX: 1228,
    d: "M195 0v1413h956v-178h-731v-438h674v-179h-674v-438h751v-180h-976zM422 1610q0 46 32 77t78 31t77.5 -31t31.5 -77t-31.5 -77.5t-77.5 -31.5t-78 31.5t-32 77.5zM739 1610q0 45 32.5 76.5t78.5 31.5t77 -31t31 -77t-31 -77.5t-77 -31.5t-78.5 31.5t-32.5 77.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    horizAdvX: 567,
    d: "M53 1716h205l129 -209h-135zM195 0v1413h225v-1413h-225z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    horizAdvX: 567,
    d: "M195 0v1413h225v-1413h-225zM229 1507l129 209h205l-198 -209h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    horizAdvX: 567,
    d: "M90 1507l135 209h166l135 -209h-155l-64 123l-63 -123h-154zM195 0v1413h225v-1413h-225z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    horizAdvX: 567,
    d: "M39 1610q0 45 32.5 76.5t78.5 31.5t77 -31t31 -77t-31 -77.5t-77 -31.5t-78.5 31.5t-32.5 77.5zM195 0v1413h225v-1413h-225zM356 1610q0 45 32.5 76.5t78.5 31.5t77 -31t31 -77t-31 -77.5t-77 -31.5t-78.5 31.5t-32.5 77.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    horizAdvX: 1466,
    d: "M68 618v136h120v659h455q108 0 180 -8q125 -15 227.5 -63.5t180 -131t120 -206.5t42.5 -281q0 -205 -76.5 -362t-205 -244.5t-294.5 -108.5q-72 -8 -180 -8h-449v618h-120zM412 180h204q117 0 162 8q172 25 273.5 165t101.5 370q0 219 -97.5 348t-269.5 154 q-59 10 -163 10h-211v-481h262v-136h-262v-438z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    horizAdvX: 1509,
    d: "M195 0v1413h317l633 -1173q-6 240 -6 493v680h221l2 -1413h-324l-626 1165q8 -216 8 -489v-676h-225zM530 1532q0 96 31 137t94 41q58 0 138 -31q74 -24 90 -24q17 0 24.5 10.5t7.5 36.5h109q0 -96 -31.5 -137t-95.5 -41q-57 0 -137 30q-77 25 -90 25q-33 0 -33 -47h-107 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    horizAdvX: 1536,
    d: "M100 707q0 164 46 299.5t132 232t215 150t289 53.5q212 0 367 -92.5t234 -258t79 -384.5t-79 -384t-234 -258.5t-367 -93.5q-213 0 -368.5 93.5t-234.5 258.5t-79 384zM342 707q0 -263 117 -413.5t323 -150.5q205 0 322 150.5t117 413.5q0 264 -116.5 413.5t-322.5 149.5 q-207 0 -323.5 -149.5t-116.5 -413.5zM528 1716h205l129 -209h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    horizAdvX: 1536,
    d: "M100 707q0 164 46 299.5t132 232t215 150t289 53.5q212 0 367 -92.5t234 -258t79 -384.5t-79 -384t-234 -258.5t-367 -93.5q-213 0 -368.5 93.5t-234.5 258.5t-79 384zM342 707q0 -263 117 -413.5t323 -150.5q205 0 322 150.5t117 413.5q0 264 -116.5 413.5t-322.5 149.5 q-207 0 -323.5 -149.5t-116.5 -413.5zM705 1507l129 209h204l-198 -209h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    horizAdvX: 1536,
    d: "M100 707q0 164 46 299.5t132 232t215 150t289 53.5q212 0 367 -92.5t234 -258t79 -384.5t-79 -384t-234 -258.5t-367 -93.5q-213 0 -368.5 93.5t-234.5 258.5t-79 384zM342 707q0 -263 117 -413.5t323 -150.5q205 0 322 150.5t117 413.5q0 264 -116.5 413.5t-322.5 149.5 q-207 0 -323.5 -149.5t-116.5 -413.5zM565 1507l135 209h166l135 -209h-155l-64 123l-63 -123h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    horizAdvX: 1536,
    d: "M100 707q0 164 46 299.5t132 232t215 150t289 53.5q212 0 367 -92.5t234 -258t79 -384.5t-79 -384t-234 -258.5t-367 -93.5q-213 0 -368.5 93.5t-234.5 258.5t-79 384zM342 707q0 -263 117 -413.5t323 -150.5q205 0 322 150.5t117 413.5q0 264 -116.5 413.5t-322.5 149.5 q-207 0 -323.5 -149.5t-116.5 -413.5zM537 1532q0 96 31 137t94 41q57 0 137 -31q74 -24 90 -24q18 0 25.5 10.5t7.5 36.5h108q0 -96 -31.5 -137t-95.5 -41q-57 0 -137 30q-77 25 -90 25q-33 0 -33 -47h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    horizAdvX: 1536,
    d: "M100 707q0 164 46 299.5t132 232t215 150t289 53.5q212 0 367 -92.5t234 -258t79 -384.5t-79 -384t-234 -258.5t-367 -93.5q-213 0 -368.5 93.5t-234.5 258.5t-79 384zM342 707q0 -263 117 -413.5t323 -150.5q205 0 322 150.5t117 413.5q0 264 -116.5 413.5t-322.5 149.5 q-207 0 -323.5 -149.5t-116.5 -413.5zM514 1610q0 45 32.5 76.5t78.5 31.5t77 -31t31 -77t-31 -77.5t-77 -31.5t-78.5 31.5t-32.5 77.5zM831 1610q0 45 32.5 76.5t78.5 31.5t77.5 -31t31.5 -77t-31.5 -77.5t-77.5 -31.5t-78.5 31.5t-32.5 77.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    d: "M225 360l291 291l-291 291l99 98l290 -290l291 290l101 -98l-291 -291l291 -291l-101 -98l-291 291l-290 -291z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    horizAdvX: 1548,
    d: "M92 109l137 137q-123 189 -123 461q0 334 181.5 534.5t500.5 200.5q287 0 469 -168l129 129l99 -98l-137 -138q122 -188 122 -460q0 -218 -79.5 -383.5t-235 -259t-367.5 -93.5q-287 0 -469 168l-129 -129zM348 707q0 -171 49 -293l711 710q-118 146 -320 146 q-207 0 -323.5 -149.5t-116.5 -413.5zM469 289q118 -146 319 -146q207 0 324 150.5t117 413.5q0 170 -49 292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    horizAdvX: 1415,
    d: "M180 547v866h223v-870q0 -74 5 -115q11 -132 94 -208.5t231 -76.5q150 0 233.5 76.5t94.5 208.5q4 33 4 115v870h223v-866q0 -93 -4 -146q-8 -91 -43.5 -167t-100.5 -136t-169 -93.5t-238 -33.5t-238 33.5t-169 93.5t-100 136t-42 167q-4 53 -4 146zM479 1716h205 l129 -209h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    horizAdvX: 1415,
    d: "M180 547v866h223v-870q0 -74 5 -115q11 -132 94 -208.5t231 -76.5q150 0 233.5 76.5t94.5 208.5q4 33 4 115v870h223v-866q0 -93 -4 -146q-8 -91 -43.5 -167t-100.5 -136t-169 -93.5t-238 -33.5t-238 33.5t-169 93.5t-100 136t-42 167q-4 53 -4 146zM655 1507l129 209 h205l-198 -209h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    horizAdvX: 1415,
    d: "M180 547v866h223v-870q0 -74 5 -115q11 -132 94 -208.5t231 -76.5q150 0 233.5 76.5t94.5 208.5q4 33 4 115v870h223v-866q0 -93 -4 -146q-8 -91 -43.5 -167t-100.5 -136t-169 -93.5t-238 -33.5t-238 33.5t-169 93.5t-100 136t-42 167q-4 53 -4 146zM516 1507l135 209 h166l135 -209h-155l-64 123l-63 -123h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    horizAdvX: 1415,
    d: "M180 547v866h223v-870q0 -74 5 -115q11 -132 94 -208.5t231 -76.5q150 0 233.5 76.5t94.5 208.5q4 33 4 115v870h223v-866q0 -93 -4 -146q-8 -91 -43.5 -167t-100.5 -136t-169 -93.5t-238 -33.5t-238 33.5t-169 93.5t-100 136t-42 167q-4 53 -4 146zM465 1610q0 46 32 77 t78 31t77.5 -31t31.5 -77t-31.5 -77.5t-77.5 -31.5t-78 31.5t-32 77.5zM782 1610q0 45 32.5 76.5t78.5 31.5t77 -31t31 -77t-31 -77.5t-77 -31.5t-78.5 31.5t-32.5 77.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    horizAdvX: 1232,
    d: "M37 1413h256l364 -653l353 653h250l-500 -860v-553h-223v553zM569 1507l129 209h205l-198 -209h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    horizAdvX: 1302,
    d: "M195 0v1413h225v-180h250q126 0 192 -8q162 -21 261.5 -123.5t99.5 -276.5t-100 -278t-261 -125q-66 -8 -192 -8h-250v-414h-225zM420 596h239q95 0 144 8q82 15 132 67.5t50 151.5q0 98 -50.5 151t-131.5 68q-55 9 -144 9h-239v-455z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    horizAdvX: 1275,
    d: "M141 0v958q0 78 4 152q12 210 148 322t348 112q221 0 348 -100.5t127 -267.5q0 -106 -61 -201q-146 -79 -146 -160q0 -50 27 -89.5t96 -100.5q92 -79 130 -149.5t38 -178.5q0 -142 -112.5 -223.5t-278.5 -81.5q-121 0 -221 20v176q102 -26 192 -26q88 0 132 41.5 t44 115.5q0 51 -25 98t-95 109q-97 89 -133.5 147.5t-36.5 141.5q0 148 172 238q34 54 34 121q0 94 -60 146t-179 52q-112 0 -182.5 -68.5t-79.5 -197.5q-4 -58 -4 -131v-975h-226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    horizAdvX: 1116,
    d: "M72 285q0 372 604 372h69v27q0 78 -4 119q-10 149 -190 149q-192 0 -211 -209h-225q10 176 130.5 274.5t309.5 98.5q202 0 299 -78.5t111 -224.5q6 -68 6 -154v-383q0 -125 20 -276h-223l-20 158l-56 -117q-102 -70 -270 -70q-151 0 -250.5 83.5t-99.5 230.5zM295 1417 h205l139 -233h-135zM309 303q0 -84 51.5 -126t143.5 -42q108 0 174.5 72t66.5 201v100q-135 10 -230.5 -7t-150.5 -67t-55 -131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    horizAdvX: 1116,
    d: "M72 285q0 372 604 372h69v27q0 78 -4 119q-10 149 -190 149q-192 0 -211 -209h-225q10 176 130.5 274.5t309.5 98.5q202 0 299 -78.5t111 -224.5q6 -68 6 -154v-383q0 -125 20 -276h-223l-20 158l-56 -117q-102 -70 -270 -70q-151 0 -250.5 83.5t-99.5 230.5zM309 303 q0 -84 51.5 -126t143.5 -42q108 0 174.5 72t66.5 201v100q-135 10 -230.5 -7t-150.5 -67t-55 -131zM475 1184l141 233h205l-211 -233h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    horizAdvX: 1116,
    d: "M72 285q0 372 604 372h69v27q0 78 -4 119q-10 149 -190 149q-192 0 -211 -209h-225q10 176 130.5 274.5t309.5 98.5q202 0 299 -78.5t111 -224.5q6 -68 6 -154v-383q0 -125 20 -276h-223l-20 158l-56 -117q-102 -70 -270 -70q-151 0 -250.5 83.5t-99.5 230.5zM309 303 q0 -84 51.5 -126t143.5 -42q108 0 174.5 72t66.5 201v100q-135 10 -230.5 -7t-150.5 -67t-55 -131zM338 1184l135 233h166l135 -233h-151l-68 133l-68 -133h-149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    horizAdvX: 1116,
    d: "M72 285q0 372 604 372h69v27q0 78 -4 119q-10 149 -190 149q-192 0 -211 -209h-225q10 176 130.5 274.5t309.5 98.5q202 0 299 -78.5t111 -224.5q6 -68 6 -154v-383q0 -125 20 -276h-223l-20 158l-56 -117q-102 -70 -270 -70q-151 0 -250.5 83.5t-99.5 230.5zM309 303 q0 -84 51.5 -126t143.5 -42q108 0 174.5 72t66.5 201v100q-135 10 -230.5 -7t-150.5 -67t-55 -131zM309 1217q0 96 31 136t94 40t137 -29q68 -25 91 -25q17 0 24.5 10.5t7.5 36.5h109q0 -98 -31.5 -138t-95.5 -40q-49 0 -137 29q-68 25 -90 25q-33 0 -33 -45h-107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    horizAdvX: 1116,
    d: "M72 285q0 372 604 372h69v27q0 78 -4 119q-10 149 -190 149q-192 0 -211 -209h-225q10 176 130.5 274.5t309.5 98.5q202 0 299 -78.5t111 -224.5q6 -68 6 -154v-383q0 -125 20 -276h-223l-20 158l-56 -117q-102 -70 -270 -70q-151 0 -250.5 83.5t-99.5 230.5zM283 1294 q0 46 31 77.5t77 31.5t78.5 -31.5t32.5 -77.5q0 -45 -32.5 -75.5t-78.5 -30.5t-77 30t-31 76zM309 303q0 -84 51.5 -126t143.5 -42q108 0 174.5 72t66.5 201v100q-135 10 -230.5 -7t-150.5 -67t-55 -131zM610 1294q0 46 31.5 77.5t77.5 31.5t77 -31.5t31 -77.5t-31 -76 t-77 -30t-77.5 30.5t-31.5 75.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    horizAdvX: 1116,
    d: "M72 285q0 372 604 372h69v27q0 78 -4 119q-10 149 -190 149q-192 0 -211 -209h-225q10 176 130.5 274.5t309.5 98.5q202 0 299 -78.5t111 -224.5q6 -68 6 -154v-383q0 -125 20 -276h-223l-20 158l-56 -117q-102 -70 -270 -70q-151 0 -250.5 83.5t-99.5 230.5zM309 303 q0 -84 51.5 -126t143.5 -42q108 0 174.5 72t66.5 201v100q-135 10 -230.5 -7t-150.5 -67t-55 -131zM354 1341q0 82 56.5 133.5t144.5 51.5t144.5 -51.5t56.5 -133.5q0 -79 -56.5 -130.5t-144.5 -51.5t-144.5 51.5t-56.5 130.5zM473 1341q0 -43 23 -68.5t59 -25.5t59 25.5 t23 68.5q0 44 -23 70.5t-59 26.5t-59 -26.5t-23 -70.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    horizAdvX: 1863,
    d: "M72 287q0 183 154 267.5t466 84.5h82v45q0 268 -217 268q-102 0 -157 -53.5t-60 -155.5h-225q4 176 123 274.5t317 98.5q287 0 369 -194q130 194 385 194q150 0 260.5 -72.5t165.5 -195t55 -277.5q0 -31 -6 -90h-776q11 -177 87.5 -261.5t192.5 -84.5q101 0 170 57.5 t86 159.5h230q-35 -186 -170 -283.5t-322 -97.5q-300 0 -420 240l-76 -127q-135 -113 -333 -113q-166 0 -273.5 83.5t-107.5 232.5zM309 305q0 -86 52.5 -128t148.5 -42q115 0 189.5 80.5t74.5 214.5v51q-238 10 -351.5 -27.5t-113.5 -148.5zM1010 639h549q-14 153 -80 233 t-183 80q-119 0 -193 -80t-93 -233z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    horizAdvX: 1114,
    d: "M59 539q0 135 42 246t114.5 182.5t167.5 110t203 38.5q202 0 328 -111t147 -294h-227q-48 241 -254 241q-125 0 -204 -101t-79 -296q0 -211 76 -315.5t198 -104.5q97 0 163 58t91 167h230q-36 -181 -155 -279.5t-300 -107.5l-29 -57q85 -10 128.5 -52.5t43.5 -113.5 q0 -88 -74.5 -134t-199.5 -46q-66 0 -107 16v105q49 -21 111 -21q63 0 95 21t32 59q0 49 -46.5 70t-150.5 14l74 143q-191 24 -304.5 166.5t-113.5 395.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    horizAdvX: 1150,
    d: "M59 541q0 257 148.5 416t384.5 159q153 0 264.5 -73t166 -194.5t54.5 -277.5q0 -51 -4 -90h-780q24 -346 285 -346q100 0 169.5 58t86.5 159h227q-34 -186 -169 -283.5t-323 -97.5q-228 0 -369 146t-141 424zM295 639h551q-12 152 -78.5 232.5t-183.5 80.5 q-118 0 -194.5 -79.5t-94.5 -233.5zM319 1417h205l140 -233h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    horizAdvX: 1150,
    d: "M59 541q0 257 148.5 416t384.5 159q153 0 264.5 -73t166 -194.5t54.5 -277.5q0 -51 -4 -90h-780q24 -346 285 -346q100 0 169.5 58t86.5 159h227q-34 -186 -169 -283.5t-323 -97.5q-228 0 -369 146t-141 424zM295 639h551q-12 152 -78.5 232.5t-183.5 80.5 q-118 0 -194.5 -79.5t-94.5 -233.5zM500 1184l141 233h205l-211 -233h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    horizAdvX: 1150,
    d: "M59 541q0 257 148.5 416t384.5 159q153 0 264.5 -73t166 -194.5t54.5 -277.5q0 -51 -4 -90h-780q24 -346 285 -346q100 0 169.5 58t86.5 159h227q-34 -186 -169 -283.5t-323 -97.5q-228 0 -369 146t-141 424zM295 639h551q-12 152 -78.5 232.5t-183.5 80.5 q-118 0 -194.5 -79.5t-94.5 -233.5zM362 1184l136 233h166l135 -233h-152l-67 133l-68 -133h-150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    horizAdvX: 1150,
    d: "M59 541q0 257 148.5 416t384.5 159q153 0 264.5 -73t166 -194.5t54.5 -277.5q0 -51 -4 -90h-780q24 -346 285 -346q100 0 169.5 58t86.5 159h227q-34 -186 -169 -283.5t-323 -97.5q-228 0 -369 146t-141 424zM295 639h551q-12 152 -78.5 232.5t-183.5 80.5 q-118 0 -194.5 -79.5t-94.5 -233.5zM307 1294q0 46 31.5 77.5t77.5 31.5t78 -31.5t32 -77.5q0 -45 -32 -75.5t-78 -30.5t-77.5 30.5t-31.5 75.5zM635 1294q0 46 31 77.5t77 31.5t77.5 -31.5t31.5 -77.5q0 -45 -31.5 -75.5t-77.5 -30.5t-77 30t-31 76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    horizAdvX: 514,
    d: "M-6 1417h205l139 -233h-135zM141 0v1087h226v-1087h-226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    horizAdvX: 514,
    d: "M141 0v1087h226v-1087h-226zM174 1184l141 233h205l-211 -233h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    horizAdvX: 514,
    d: "M37 1184l135 233h166l135 -233h-151l-68 133l-68 -133h-149zM141 0v1087h226v-1087h-226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    horizAdvX: 514,
    d: "M-18 1294q0 46 31 77.5t77 31.5t78.5 -31.5t32.5 -77.5q0 -45 -32.5 -75.5t-78.5 -30.5t-77 30t-31 76zM141 0v1087h226v-1087h-226zM309 1294q0 46 31.5 77.5t77.5 31.5t77 -31.5t31 -77.5t-31 -76t-77 -30t-77.5 30.5t-31.5 75.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    horizAdvX: 1236,
    d: "M59 532q0 135 41 246.5t111 184.5t161 113t193 40q69 0 120.5 -13t107.5 -46l92 -121q-18 183 -127 301l-281 -94l-37 117l207 71q-61 39 -155 76l161 119q129 -56 209 -123l148 51l37 -119l-86 -28q95 -118 138.5 -284t43.5 -394q0 -117 -21 -215.5t-59 -169.5t-89 -124 t-113 -85.5t-128.5 -48t-138.5 -15.5q-174 0 -296.5 73.5t-180.5 198t-58 289.5zM299 547q0 -194 77.5 -300t225.5 -106q136 0 219.5 100.5t83.5 290.5v60q0 90 -26 160.5t-69.5 112t-96.5 62.5t-111 21q-138 0 -220.5 -110t-82.5 -291z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    horizAdvX: 1241,
    d: "M141 0v1087h226v-180l73 125q62 48 125.5 66t149.5 18q172 0 272 -83t115 -228q6 -83 6 -193v-612h-225v588q0 98 -4 153q-8 98 -64 153.5t-166 55.5q-127 0 -204.5 -111t-77.5 -352v-487h-226zM387 1217q0 96 31 136t94 40t137 -29q68 -25 90 -25q18 0 25.5 10.5 t7.5 36.5h109q0 -98 -31.5 -138t-95.5 -40q-50 0 -138 29q-68 25 -90 25q-32 0 -32 -45h-107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    horizAdvX: 1218,
    d: "M59 545q0 120 35 223t102 181t173.5 122.5t240.5 44.5q133 0 239.5 -44.5t173.5 -122.5t102.5 -181t35.5 -223t-35.5 -223.5t-102.5 -182t-173.5 -123.5t-239.5 -45q-134 0 -240.5 45t-173.5 123.5t-102 182t-35 223.5zM297 545q0 -187 83 -298.5t230 -111.5 q146 0 229 111.5t83 298.5t-83 297t-229 110q-147 0 -230 -110t-83 -297zM350 1417h205l139 -233h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    horizAdvX: 1218,
    d: "M59 545q0 120 35 223t102 181t173.5 122.5t240.5 44.5q133 0 239.5 -44.5t173.5 -122.5t102.5 -181t35.5 -223t-35.5 -223.5t-102.5 -182t-173.5 -123.5t-239.5 -45q-134 0 -240.5 45t-173.5 123.5t-102 182t-35 223.5zM297 545q0 -187 83 -298.5t230 -111.5 q146 0 229 111.5t83 298.5t-83 297t-229 110q-147 0 -230 -110t-83 -297zM530 1184l142 233h205l-211 -233h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    horizAdvX: 1218,
    d: "M59 545q0 120 35 223t102 181t173.5 122.5t240.5 44.5q133 0 239.5 -44.5t173.5 -122.5t102.5 -181t35.5 -223t-35.5 -223.5t-102.5 -182t-173.5 -123.5t-239.5 -45q-134 0 -240.5 45t-173.5 123.5t-102 182t-35 223.5zM297 545q0 -187 83 -298.5t230 -111.5 q146 0 229 111.5t83 298.5t-83 297t-229 110q-147 0 -230 -110t-83 -297zM393 1184l135 233h166l135 -233h-151l-68 133l-67 -133h-150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    horizAdvX: 1218,
    d: "M59 545q0 120 35 223t102 181t173.5 122.5t240.5 44.5q133 0 239.5 -44.5t173.5 -122.5t102.5 -181t35.5 -223t-35.5 -223.5t-102.5 -182t-173.5 -123.5t-239.5 -45q-134 0 -240.5 45t-173.5 123.5t-102 182t-35 223.5zM297 545q0 -187 83 -298.5t230 -111.5 q146 0 229 111.5t83 298.5t-83 297t-229 110q-147 0 -230 -110t-83 -297zM365 1217q0 96 30.5 136t93.5 40q64 0 138 -29q68 -25 90 -25q18 0 25.5 10.5t7.5 36.5h108q0 -98 -31.5 -138t-95.5 -40q-49 0 -137 29q-68 25 -90 25q-33 0 -33 -45h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    horizAdvX: 1218,
    d: "M59 545q0 120 35 223t102 181t173.5 122.5t240.5 44.5q133 0 239.5 -44.5t173.5 -122.5t102.5 -181t35.5 -223t-35.5 -223.5t-102.5 -182t-173.5 -123.5t-239.5 -45q-134 0 -240.5 45t-173.5 123.5t-102 182t-35 223.5zM297 545q0 -187 83 -298.5t230 -111.5 q146 0 229 111.5t83 298.5t-83 297t-229 110q-147 0 -230 -110t-83 -297zM338 1294q0 46 31 77.5t77 31.5t78.5 -31.5t32.5 -77.5q0 -45 -32.5 -75.5t-78.5 -30.5t-77 30t-31 76zM666 1294q0 46 31 77.5t77 31.5t77.5 -31.5t31.5 -77.5q0 -45 -31.5 -75.5t-77.5 -30.5 t-77 30t-31 76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    d: "M168 586v135h895v-135h-895zM492 307q0 54 36 90.5t90 36.5t90.5 -36.5t36.5 -90.5t-36.5 -90.5t-90.5 -36.5t-90 36.5t-36 90.5zM492 991q0 54 36 90.5t90 36.5t90.5 -36.5t36.5 -90.5t-36.5 -90.5t-90.5 -36.5t-90 36.5t-36 90.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    horizAdvX: 1280,
    d: "M51 53l127 127q-104 149 -104 365q0 120 35.5 223t102.5 181t173.5 122.5t239.5 44.5q227 0 366 -123l139 140l99 -99l-146 -145q93 -146 93 -344q0 -120 -35 -223.5t-102 -182t-173.5 -123.5t-240.5 -45q-210 0 -351 109l-124 -125zM313 545q0 -111 31 -199l504 504 q-82 102 -223 102q-146 0 -229 -110t-83 -297zM416 221q80 -86 209 -86q147 0 230 111.5t83 298.5q0 93 -25 176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    horizAdvX: 1236,
    d: "M125 440v647h223v-602q0 -76 8 -149q12 -92 72 -144.5t162 -52.5q127 0 201.5 105.5t74.5 330.5v512h224v-1087h-224v186l-75 -135q-63 -44 -126.5 -62t-148.5 -18q-161 0 -261 79t-120 198q-10 69 -10 192zM346 1417h205l139 -233h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    horizAdvX: 1236,
    d: "M125 440v647h223v-602q0 -76 8 -149q12 -92 72 -144.5t162 -52.5q127 0 201.5 105.5t74.5 330.5v512h224v-1087h-224v186l-75 -135q-63 -44 -126.5 -62t-148.5 -18q-161 0 -261 79t-120 198q-10 69 -10 192zM526 1184l142 233h204l-210 -233h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    horizAdvX: 1236,
    d: "M125 440v647h223v-602q0 -76 8 -149q12 -92 72 -144.5t162 -52.5q127 0 201.5 105.5t74.5 330.5v512h224v-1087h-224v186l-75 -135q-63 -44 -126.5 -62t-148.5 -18q-161 0 -261 79t-120 198q-10 69 -10 192zM389 1184l135 233h166l135 -233h-151l-68 133l-67 -133h-150z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    horizAdvX: 1236,
    d: "M125 440v647h223v-602q0 -76 8 -149q12 -92 72 -144.5t162 -52.5q127 0 201.5 105.5t74.5 330.5v512h224v-1087h-224v186l-75 -135q-63 -44 -126.5 -62t-148.5 -18q-161 0 -261 79t-120 198q-10 69 -10 192zM334 1294q0 46 31 77.5t77 31.5t78.5 -31.5t32.5 -77.5 q0 -45 -32.5 -75.5t-78.5 -30.5t-77 30t-31 76zM662 1294q0 46 31 77.5t77 31.5t77.5 -31.5t31.5 -77.5q0 -45 -31.5 -75.5t-77.5 -30.5t-77 30t-31 76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    horizAdvX: 1099,
    d: "M2 1087h252l299 -919l297 919h244l-443 -1157q-75 -194 -170 -277t-243 -83q-74 0 -107 6v166q27 -2 72 -2q79 0 132 39t89 131l16 39zM469 1184l141 233h205l-211 -233h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    horizAdvX: 1282,
    d: "M141 -401v1906h226v-587l82 116q45 38 122.5 60t161.5 22q152 0 264 -72.5t169 -197t57 -283.5q0 -145 -42.5 -260t-116 -186.5t-167.5 -108.5t-201 -37q-71 0 -144.5 18.5t-113.5 49.5l-71 108v-548h-226zM367 500q0 -95 27 -168.5t71.5 -114.5t96.5 -61.5t108 -20.5 q140 0 227.5 106t87.5 302q0 182 -80.5 295.5t-224.5 113.5q-66 0 -120.5 -21.5t-98.5 -67t-69 -124t-25 -184.5v-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    horizAdvX: 1099,
    d: "M2 1087h252l299 -919l297 919h244l-443 -1157q-75 -194 -170 -277t-243 -83q-74 0 -107 6v166q27 -2 72 -2q79 0 132 39t89 131l16 39zM276 1294q0 46 31.5 77.5t77.5 31.5t78.5 -31.5t32.5 -77.5q0 -45 -32.5 -75.5t-78.5 -30.5t-77.5 30.5t-31.5 75.5zM604 1294 q0 46 31.5 77.5t77.5 31.5t77 -31.5t31 -77.5t-31 -76t-77 -30t-77.5 30.5t-31.5 75.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0152",
    horizAdvX: 2254,
    d: "M100 707q0 211 77.5 377t225 262t342.5 96q151 0 245 -35t173 -121l58 -141v268h956v-178h-731v-438h674v-179h-674v-438h752v-180h-977v264l-58 -141q-78 -81 -178 -116.5t-240 -35.5q-194 0 -342 96.5t-225.5 263t-77.5 376.5zM342 707q0 -256 117.5 -410t322.5 -154 q204 0 321.5 154t117.5 410q0 258 -117.5 410.5t-321.5 152.5q-205 0 -322.5 -152t-117.5 -411z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0153",
    horizAdvX: 2015,
    d: "M59 545q0 120 35 223t102 181t173.5 122.5t240.5 44.5q302 0 432 -248q134 248 418 248q150 0 261 -72.5t166 -195t55 -277.5q0 -22 -7 -90h-776q6 -90 30 -158t62.5 -108.5t85.5 -60t103 -19.5q101 0 170 57.5t86 159.5h229q-24 -125 -96 -212.5t-172 -128t-221 -40.5 q-276 0 -402 240q-129 -240 -424 -240q-134 0 -240.5 45t-173.5 123.5t-102 182t-35 223.5zM297 545q0 -187 83 -298.5t230 -111.5q146 0 229 111.5t83 298.5t-83 297t-229 110q-147 0 -230 -110t-83 -297zM1161 639h549q-14 153 -79.5 233t-182.5 80q-119 0 -193.5 -80 t-93.5 -233z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0178",
    horizAdvX: 1232,
    d: "M37 1413h256l364 -653l353 653h250l-500 -860v-553h-223v553zM379 1610q0 46 32 77t78 31t77.5 -31t31.5 -77t-31.5 -77.5t-77.5 -31.5t-78 31.5t-32 77.5zM696 1610q0 45 32.5 76.5t78.5 31.5t77 -31t31 -77t-31 -77.5t-77 -31.5t-78.5 31.5t-32.5 77.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02C6",
    horizAdvX: 614,
    d: "M90 1184l135 233h166l135 -233h-151l-68 133l-67 -133h-150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DC",
    horizAdvX: 614,
    d: "M61 1217q0 96 31 136t94 40q64 0 138 -29q68 -25 90 -25q17 0 24.5 10.5t7.5 36.5h109q0 -98 -31.5 -138t-95.5 -40q-49 0 -137 29q-68 25 -90 25q-33 0 -33 -45h-107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2000",
    horizAdvX: 910
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2001",
    horizAdvX: 1821
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2002",
    horizAdvX: 910
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2003",
    horizAdvX: 1821
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2004",
    horizAdvX: 607
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2005",
    horizAdvX: 455
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2006",
    horizAdvX: 303
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2007",
    horizAdvX: 303
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2008",
    horizAdvX: 227
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2009",
    horizAdvX: 364
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u200A",
    horizAdvX: 101
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2010",
    horizAdvX: 581,
    d: "M66 512v135h450v-135h-450z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2011",
    horizAdvX: 581,
    d: "M66 512v135h450v-135h-450z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2012",
    horizAdvX: 581,
    d: "M66 512v135h450v-135h-450z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    horizAdvX: 1024,
    d: "M154 530v136h716v-136h-716z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    horizAdvX: 2048,
    d: "M154 530v136h1740v-136h-1740z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    horizAdvX: 544,
    d: "M113 971v20l200 514h189l-160 -534h-229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    horizAdvX: 544,
    d: "M43 971l160 534h229v-20l-201 -514h-188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    horizAdvX: 475,
    d: "M-61 -248l161 490h228v-21l-193 -469h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    horizAdvX: 927,
    d: "M113 971v20l200 516h189l-160 -536h-229zM496 971v20l200 516h189l-160 -536h-229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    horizAdvX: 927,
    d: "M43 971l160 534h229v-20l-201 -514h-188zM426 971l162 534h227v-20l-199 -514h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    horizAdvX: 858,
    d: "M-61 -248l161 490h228v-21l-193 -469h-196zM324 -248l159 490h230v-21l-195 -469h-194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    horizAdvX: 759,
    d: "M154 625q0 98 64.5 162.5t162.5 64.5q97 0 161 -64.5t64 -162.5t-64 -162t-161 -64q-98 0 -162.5 64t-64.5 162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2026",
    horizAdvX: 1376,
    d: "M78 121q0 66 41.5 107.5t107.5 41.5q65 0 107.5 -41.5t42.5 -107.5q0 -65 -42.5 -107.5t-107.5 -42.5q-66 0 -107.5 42.5t-41.5 107.5zM528 121q0 66 42 107.5t108 41.5q65 0 107 -41.5t42 -107.5q0 -65 -42.5 -107.5t-106.5 -42.5q-66 0 -108 42.5t-42 107.5zM979 121 q0 66 41.5 107.5t107.5 41.5q65 0 107.5 -41.5t42.5 -107.5q0 -65 -43 -107.5t-107 -42.5q-66 0 -107.5 42.5t-41.5 107.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u202F",
    horizAdvX: 364
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    horizAdvX: 829,
    d: "M260 508l281 340h178l-281 -340l281 -340h-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    horizAdvX: 811,
    d: "M111 168l280 340l-280 340h178l280 -340l-280 -340h-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u205F",
    horizAdvX: 455
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u20AC",
    d: "M66 514l24 135h115v51q0 40 2 58h-98l26 135h84q43 274 205 411.5t407 137.5q240 0 355 -127l-96 -144q-99 99 -256 99q-313 0 -373 -377h575l-28 -135h-559v-49v-60h540l-22 -135h-506q28 -195 121 -283t249 -88q173 0 302 82v-176q-137 -78 -332 -78q-256 0 -404 126.5 t-182 416.5h-149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2122",
    horizAdvX: 1103,
    d: "M43 1266v86h408v-86h-150v-332h-108v332h-150zM500 934v416h162l83 -310l82 310h158v-416h-108l4 291l-82 -283h-113l-80 281l2 -289h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u25FC",
    horizAdvX: 1085,
    d: "M0 0v1085h1085v-1085h-1085z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "U",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "U",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "U",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "U",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "U",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "U",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "U",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "z",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "period,ellipsis",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla",
    g2: "T",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,uniFB02",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,uniFB02",
    g2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "T",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "Y,Yacute,Ydieresis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,oe",
    g2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,oe",
    g2: "y,yacute,ydieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "T",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "Y,Yacute,Ydieresis",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "V",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "W",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "Z",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "period,ellipsis",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "T",
    k: 276
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "Y,Yacute,Ydieresis",
    k: 322
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "V",
    k: 225
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "W",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "T",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "v",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "Y,Yacute,Ydieresis",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "y,yacute,ydieresis",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "V",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "W",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "quoteright,quotedblright",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "S",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "w",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "m,n,p,r,ntilde",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "i,igrave,iacute,icircumflex,idieresis",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "b,h,k,thorn",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "x",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "y,yacute,ydieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 43
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAileronSemiboldWebfont);
export default __webpack_public_path__ + "static/media/aileron-semibold-webfont.09cf78ddf019c8c0eb45b243a1880899.svg";
export { ForwardRef as ReactComponent };